import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Button, ButtonDropdown } from 'components/misc'
import { CircleLoader } from 'components/loaders'
import cx from 'classnames'
import styles from './module.styl'
import get from 'lodash/get'
import downloadLink from '../../../helpers/decorators/DownloadLink/DownloadLink'

const DownloadButton = downloadLink(Button)

export default class Module extends Component {
  static propTypes = {
    first: PropTypes.bool,
    primary: PropTypes.bool,
    grid: PropTypes.bool,
    plain: PropTypes.bool,
    narrow: PropTypes.bool,
    verticallyNarrow: PropTypes.bool,
    verticallyNarrowExtra: PropTypes.bool,
    noBottomPadding: PropTypes.bool,
    hasError: PropTypes.bool,
    children: PropTypes.any,
    title: PropTypes.string,
    action: PropTypes.string,
    actionDropdown: PropTypes.string,
    iconAction: PropTypes.string,
    intlKey: PropTypes.string,
    actionDropdownActions: PropTypes.array,
    style: PropTypes.object,
    loading: PropTypes.bool,
    isActionLoading: PropTypes.bool,
    buttonDefinition: PropTypes.array
  }

  static defaultProps = {
    title: null,
    primary: false,
    grid: false,
    plain: false,
    narrow: false,
    verticallyNarrow: false,
    verticallyNarrowExtra: false,
    noBottomPadding: false,
    hasError: false,
    first: false,
    loading: false,
    isActionLoading: false,
    iconAction: null,
    style: {}
  }

  render() {
    const {
      title,
      children,
      primary,
      first,
      grid,
      narrow,
      hasError,
      action,
      actionDropdown,
      iconAction,
      onClick,
      plain,
      intlKey,
      intlKeyAction,
      style,
      loading,
      verticallyNarrow,
      verticallyNarrowExtra,
      noBottomPadding,
      actionDropdownActions,
      buttonDefinition
    } = this.props


    const buttons = []

    buttonDefinition && buttonDefinition.map(def => {

      if( get(def, 'action')){

        if(get(def, 'isDownload')){
          buttons.push(
            (<DownloadButton
              type="button"
              secondary={get(def, 'secondary')}
              onClick={get(def, 'onClick')}
              icon={get(def, 'iconAction')}
              className={get(def, 'order') === 1 ? styles.action : `${styles.action} ${styles.btnSecondary}`}
              isLoading={get(def, 'isActionLoading')}
              url={get(def, 'url')}
            >
              {get(def, 'intlKeyAction')
                ? <FormattedMessage
                  id={get(def, 'intlKeyAction')}
                  defaultMessage={get(def, 'action')}
                />
                : get(def, 'action')}
            </DownloadButton>)
          )
        } else {
          buttons.push(
            (<Button
              type="button"
              secondary={get(def, 'secondary')}
              onClick={get(def, 'onClick')}
              icon={get(def, 'iconAction')}
              className={get(def, 'order') === 1 ? styles.action : `${styles.action} ${styles.btnSecondary}`}
              isLoading={get(def, 'isActionLoading')}
            >
              {get(def, 'intlKeyAction')
                ? <FormattedMessage
                  id={get(def, 'intlKeyAction')}
                  defaultMessage={get(def, 'action')}
                />
                : get(def, 'action')}
            </Button>)
          )
        }


      }
    })

    return (
      <div
        className={cx(styles.module, {
          [styles.primary]: primary,
          [styles.first]: first,
          [styles.grid]: grid,
          [styles.plain]: plain,
          [styles.narrow]: narrow,
          [styles.hasError]: hasError,
          [styles.verticallyNarrow]: verticallyNarrow,
          [styles.verticallyNarrowExtra]: verticallyNarrowExtra,
          [styles.noBottomPadding]: noBottomPadding,
          [styles.withTitle]: title,
          [styles.loading]: loading
        })}
        style={style}
      >
        {(title || action) &&
          <div className={styles.header}>
            {title &&
              <h2 className={styles.title}>
                {intlKey
                  ? <FormattedMessage id={intlKey} defaultMessage={title} />
                  : title}
              </h2>}

            <div>
              {buttons}
            </div>

            {actionDropdown &&
              <ButtonDropdown
                type="button"
                secondary
                onClick={onClick}
                icon={iconAction}
                className={styles.action}
                actions={actionDropdownActions}
                right
              >
                {intlKeyAction
                  ? <FormattedMessage
                    id={intlKeyAction}
                    defaultMessage={actionDropdown}
                  />
                  : actionDropdown}
              </ButtonDropdown>}
          </div>}
        {children}
        {loading &&
          <div className={styles.loader}>
            <CircleLoader size={60} />
          </div>}
      </div>
    )
  }
}
